module.exports = __webpack_public_path__ + "img/oeegoal.c7960cea.svg";